import { render, staticRenderFns } from "./MarkupTableEmptyRow.vue?vue&type=template&id=25d379f4&scoped=true&"
import script from "./MarkupTableEmptyRow.vue?vue&type=script&lang=ts&"
export * from "./MarkupTableEmptyRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25d379f4",
  null
  
)

export default component.exports